import { render, staticRenderFns } from "./ReserveManager.vue?vue&type=template&id=020a50cf&"
import script from "./ReserveManager.vue?vue&type=script&lang=js&"
export * from "./ReserveManager.vue?vue&type=script&lang=js&"
import style0 from "./ReserveManager.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports